module.exports = __webpack_public_path__ + "static/media/icon_workboard_eraser.b112890a.svg";